import { render, staticRenderFns } from "./CustomerCredits.vue?vue&type=template&id=1caf58de"
import script from "./CustomerCredits.vue?vue&type=script&lang=js"
export * from "./CustomerCredits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports